import { useState } from 'preact/hooks';
import { ROTULO_STATUS } from '../format';
import type { StatusAcao } from '../types';
import { Selo } from '../ui';

const TOM_STATUS: Record<StatusAcao, 'verde' | 'azul' | 'ambar' | 'vermelho' | 'cinza'> = {
  PLANEJADA: 'cinza',
  EM_ANDAMENTO: 'azul',
  CONCLUIDA: 'verde',
  SUSPENSA: 'ambar',
  CANCELADA: 'vermelho',
};

export function ChipStatus({ status, atrasada }: { status: StatusAcao; atrasada?: boolean }) {
  return (
    <>
      <Selo texto={ROTULO_STATUS[status] ?? status} tom={TOM_STATUS[status]} />
      {atrasada && <Selo texto="Atrasada" tom="vermelho" />}
    </>
  );
}

/** Contador para refazer uma consulta depois de gravar algo. */
export function useRecarga(): [number, () => void] {
  const [n, setN] = useState(0);
  return [n, () => setN((x) => x + 1)];
}

export const STATUS_OPCOES: StatusAcao[] = ['PLANEJADA', 'EM_ANDAMENTO', 'CONCLUIDA', 'SUSPENSA', 'CANCELADA'];

/** "2026-10-28T15:04:05Z" -> "28/10/2026 12:04" no fuso de Fortaleza. */
export function dataHora(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Fortaleza', dateStyle: 'short', timeStyle: 'short' }).format(new Date(iso));
}

export function tamanhoLegivel(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;
}
